import { updateUrlFromState } from "../../utils/url.write";
import { applySort, resetSort } from "./sorting";
import {setAppLoadedPromise, setAppLoadingPromise} from "./loading";

export const SET_IMMUTABLE_SEARCHING_DATA = 'SET_IMMUTABLE_SEARCHING_DATA';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const CALCULATE_SEARCHED_ROW_KEYS = 'CALCULATE_SEARCHED_ROW_KEYS';


export function setImmutableSearchingData(fields, searchIndex) {
    return {
        type: SET_IMMUTABLE_SEARCHING_DATA,
        fields,
        searchIndex,
    }
}

export function setSearchQueryAndApply(searchQuery) {
    /**
     * Action that sets the search query and then applies a search with that new query.
     *
     * */
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( setSearchQuery(searchQuery) )
            resolve()
        }).then( () => dispatch( applySearch() ) )
    }
}

function setSearchQuery(searchQuery) {
    return {
        type: SET_SEARCH_QUERY,
        searchQuery
    }
}

export function applySearch() {
    /**
     * Wraps calculateSearchedRowKeys so we can feed in current state from other parts of the store, and use Promise.
     *
     * */

    return function (dispatch, getState) {
        dispatch( setAppLoadingPromise() )
        .then(() => {
            return new Promise(function (resolve, reject) {
                const { immutableSearching, mutableFiltering } = getState();
                dispatch(calculateSearchedRowKeys(mutableFiltering.filteredRowKeys, immutableSearching.searchIndex));
                resolve()
            })
        })
        .then(() => dispatch( applySort() ))  // we changed the searched data so we need to sort it again
    }
}

export function calculateSearchedRowKeys(initialRowKeys, searchIndex) {
    return {
        type: CALCULATE_SEARCHED_ROW_KEYS,
        initialRowKeys,
        searchIndex
    }
}

